





import { defineComponent, computed, PropType } from "@vue/composition-api";
import { EmbedImage } from "@psychlab/types/form";
import { RenderImage } from "@form-ui";
import { getBaseProps } from "./getBaseProps";

export default defineComponent({
	props:{
		...getBaseProps<EmbedImage>(),
		config:{
			type:Object as PropType<EmbedImage>,
			required:true
		}
	},
	components:{
		RenderImage,
	},
	setup(props){

		const args = computed(() => ({
			title:!props.config.hideName ? props.config.name : '',
			body:props.config.body,
			theme:props.theme,
			url:props.config.settings.url,
			metadata:props.config.settings.metadata,
			width:props.config.settings.width,
		}));

		return {
			args,
		}
	}
});

